<template>
	<el-card class="box-card" shadow="never">
		<p class="card-title">订单信息</p>
		<el-row>
			<el-col class="order-left" :span="9">
				<div class="order-info">
					<div class="dt">订单号</div>
					<div class="dd">{{list.order_num}}</div>
				</div>

				<div class="order-info">
					<div class="dt">订单来源</div>
					<div class="dd"><span v-if="list.buy_method ==1">电脑端</span></div>
					<div class="dd"><span v-if="list.buy_method ==2">手机端</span></div>
				</div>
				<div class="order-info">
					<div class="dt">支付方式</div>
					<div class="dd">
						<span v-if="list.pay_method ==0">未选择支付方式</span>
						<span v-if="list.pay_method ==1">Visa</span>
						<span v-if="list.pay_method ==2">Master</span>
						<span v-if="list.pay_method ==3">JCB</span>
						<span v-if="list.pay_method ==4">Diners</span>
						<span v-if="list.pay_method ==5">AE</span>
						<span v-if="list.pay_method ==6">银行转账</span>
					</div>
				</div>
				<div class="order-info">
					<div class="dt">快递单号</div>
					<div class="dd">
						<span>{{list.express_num}}</span>
					</div>
				</div>
				<div class="order-info">
					<div class="dt">买家</div>
					<div class="dd">
						<span>{{list.customer.last_name}}{{list.customer.first_name}}</span>
					</div>
				</div>
				<div class="order-info">
					<div class="dt">买家备注</div>
					<div class="dd">{{list.comments}}</div>
				</div>
				<el-divider></el-divider>
				<div class="order-info">
					<div class="dt">卖家备注</div>
					<div class="dd">{{list.sellers_remark}}</div>
				</div>
			</el-col>
			<el-col style="padding-left: 20px!important;" :span="10">
				<div class="order-info">
					<div class="dt">收货人姓名</div>
					<div class="dd">{{list.order_address.customer_name}}</div>
				</div>
				<div class="order-info">
					<div class="dt">收货地址</div>
					<div class="dd">{{list.order_address.street}}&nbsp;{{list.order_address.place_name}}&nbsp;{{list.order_address.city_name}}&nbsp;{{list.order_address.province_name}}</div>
				</div>
				<div class="order-info">
					<div class="dt">邮编</div>
					<div class="dd">{{list.order_address.postcode}}</div>
				</div>
				<div class="order-info">
					<div class="dt">收货人手机</div>
					<div class="dd">{{list.order_address.phone}}</div>
				</div>
				<div class="order-info">
					<div class="dt">收货人邮箱</div>
					<div class="dd">{{list.customer.email}}</div>
				</div>
				<el-divider></el-divider>
				<div style="display: inline-flex;">
					<el-button v-if="list.order_status==1" @click="payment(list.id,list.customer.id)" type="success" size="small">设为付款</el-button>
					<el-button v-if="list.order_status>=2 && list.order_status<5" @click="setSellersRemark(list)" size="small">备注</el-button>
					<el-button v-if="list.order_status<=3" @click="modifyOrder(list)" size="small">修改订单</el-button>
					<el-button v-if="list.order_status==2" @click="distribution(list.id)" size="small">设为配货制作中</el-button>
					<el-button v-if="list.order_status==3" @click="cancelDistribution(list.id)" type="warning" size="small">取消配货</el-button>
					<el-button v-if="list.order_status==3" @click="confirmDelivery(list.id,list.customer.id)" type="primary" size="small">确认发货</el-button>
					<el-button v-if="list.order_status>3" @click="modifyExpressNum(list)" type="primary" size="small">编辑快递单号</el-button>
				</div>
			</el-col>
			<el-col :span="4">
				<el-tooltip class="item" effect="dark" content="请选择对应邮件模板" placement="top-start">
					<el-button type="success" @click="email_template = true" icon="el-icon-message" circle></el-button>
				</el-tooltip>
				<el-drawer title="邮件模板类型" v-model="email_template" direction="rtl" size="50%">
					<el-table :data="emailData" border highlight-current-row v-loading="loading_email">
						<el-table-column type="expand">
							<template #default="scope">
								<el-form label-position="left" inline class="demo-table-expand">
									<el-form-item>
										<!-- <i slot="label" class="el-icon-copy-document" @click='copy_email(scope.row.email_content)'>&nbsp;&nbsp;&nbsp;邮件模板</i> -->
										<div v-html="scope.row.email_content"></div>
										<!-- <div :style="email_width?'width: '+email_width+';':''" v-html="scope.row.email_content"></div> -->
									</el-form-item>
								</el-form>
							</template>
						</el-table-column>
						<el-table-column prop="id" label="ID" align="center">
						</el-table-column>
						<el-table-column prop="name" label="邮件模板" align="center"></el-table-column>
					</el-table>
				</el-drawer>
			</el-col>
		</el-row>
		<el-collapse v-model="activeNames">
			<el-collapse-item title="商品列表" name="goods">
				<el-table style="margin-top: -15px;" :data="tableData">
					<el-table-column label="商品名称" min-width="300">
						<template v-slot="scope">
							<el-image class="product-img" :src="this.getImgPrefix()+scope.row.thumb_image"
							 fit="contain" lazy>
							</el-image>
							<div class="goods-info">
								<p>
									{{scope.row.product_name}}
								</p>
								<p>
									{{scope.row.product_model}}
								</p>
								<p style="display: inline-block;font-size: 13px;color: #909399;" v-for="(i,k) in scope.row.order_product_attributes">
									{{i.key}}:{{i.value}}&nbsp;&nbsp;
								</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="单价">
						<template v-slot="scope">
							{{scope.row.price}}
						</template>
					</el-table-column>
					<el-table-column label="数量" prop="num">
					</el-table-column>
					<el-table-column label="小计">
						<template v-slot="scope">
							{{scope.row.price*scope.row.num}}
						</template>
					</el-table-column>
					<el-table-column label="状态">
						<span v-if="list.order_status ==1">等待买家付款</span>
						<span v-if="list.order_status ==2">买家已付款</span>
						<span v-if="list.order_status ==3">未发货</span>
						<span v-if="list.order_status ==4">交易成功</span>
						<span v-if="list.order_status ==5">已退款</span>
					</el-table-column>
				</el-table>
				<div class="cs-fr cs-p">
					<div class="order-info" v-for="(item,index) in list.order_total">
						<div class="dt">{{item.title}}</div>
						<div class="dd number">{{item.text}}</div>
					</div>
					<!-- <div class="order-info">
						<div class="dt">邮费</div>
						<div class="dd number">{{list.shipping}}</div>
					</div>
					<div class="order-info">
						<div class="dt">总计</div>
						<div class="dd number">{{list.total}}</div>
					</div> -->
				</div>
			</el-collapse-item>
			<el-collapse-item title="订单日志" name="log">
				<div class="block">
					<el-timeline>
						<el-timeline-item v-for="(activity, index) in list.order_log" :key="index" :timestamp="activity.created_at">
							<span>操作人员:</span>{{activity.name}}
							<br>
							{{activity.description}}
						</el-timeline-item>
					</el-timeline>
				</div>
			</el-collapse-item>
		</el-collapse>
	</el-card>
	<el-dialog title="修改订单" v-model="dialogFormVisible" width="900px">
		<el-form :model="form" ref="form" :rules="rules" label-width="120px">
			<el-form-item label="收货人姓名" prop="customer_name">
				<el-input v-model="form.customer_name" size="small" placeholder="收货人姓名"></el-input>
			</el-form-item>
			<el-form-item label="都道府県" prop="state_id">
				<el-cascader ref="cascader" v-model="form.state_id" :options="options" placeholder="请为商品选择分类" :props="props"
				 clearable filterable></el-cascader>
			</el-form-item>
			<el-form-item label="收货人手机号" prop="phone">
				<el-input v-model="form.phone" size="small" placeholder="收货人手机号"></el-input>
			</el-form-item>
			<el-form-item label="详细地址" prop="street">
				<el-input v-model="form.street" size="small" placeholder="详细地址"></el-input>
			</el-form-item>
			<el-form-item label="收货人邮编" prop="postcode">
				<el-input v-model="form.postcode" size="small" placeholder="收货人邮编"></el-input>
			</el-form-item>
			<el-form-item>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="submit()">确 定</el-button>
					<el-button @click="dialogFormVisible = false">取 消</el-button>
				</div>
			</el-form-item>
		</el-form>
	</el-dialog>
	<el-dialog
	  title="填写快递单号"
	  v-model="dialogExpress"
	  width="30%"
	  >
	  <span><el-input v-model="form1.express_num" placeholder="请填写快递单号"></el-input></span>
	  <div class="block" style="margin-top: 20px;">
			<el-select v-model="form1.express_type" placeholder="请选择">
				<el-option v-for="item in expressTypeData" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
		</div>
		<span style="margin-top: 20px;display: block;"><el-input type="textarea"  :rows="4" v-model="form1.email_content" placeholder="请填写内容"></el-input></span>
	  <template #footer>
	    <span class="dialog-footer">
	      <el-button @click="dialogExpress = false">取 消</el-button>
	      <el-button type="primary" @click="confirmDeliverySubmit()">确 定</el-button>
	    </span>
	  </template>
	</el-dialog>
	<el-dialog
	  title="卖家备注"
	  v-model="dialogSellers"
	  width="30%"
	  >
	  <span><el-input type="textarea"  :rows="4" v-model="form2.sellers_remark" placeholder="请填写卖家备注"></el-input></span>
	  <template #footer>
	    <span class="dialog-footer">
	      <el-button @click="dialogSellers = false">取 消</el-button>
	      <el-button type="primary" @click="confirmSellersSubmit()">确 定</el-button>
	    </span>
	  </template>
	</el-dialog>
</template>

<script>
	export default {
		name: 'OrderInfo',
		data() {
			return {
				email_width: '800px',
				email_template: false,
				loading_email: true,
				list: {
					order_address: [],
					customer: [],
				},
				form: {
					customer_name: '',
					state_id: [],
					phone: '',
					street: '',
					postcode: ''
				},
				props: {
					value: 'id',
					label: 'state',
					children: 'all_children'
				},
				options: [],
				form1: {
					express_num: '',
					order_id: '',
					order_status: '',
					express_type: '',
					email_content: '',
				},
				form2:{
					sellers_remark:'',
					id:'',
				},
				expressTypeData: [{
					value: '1',
					label: 'DHL'
				}, {
					value: '2',
					label: 'EMS'
				}],
				rules: {
					customer_name: [{
						required: true,
						message: '请填写收货人姓名',
						trigger: 'blur'
					}],
					state_id: [{
						required: true,
						message: '都道府県不能为空',
						trigger: 'change'
					}],
					phone: [{
						required: true,
						message: '请填写收货人手机号',
						trigger: 'blur'
					}],
					street: [{
						required: true,
						message: '请填写详细地址',
						trigger: 'blur'
					}],
					postcode: [{
						required: true,
						message: '请填写收货人邮编',
						trigger: 'blur'
					}],
				},
				tableData: [],
				activeNames: ['goods', 'log'],
				dialogFormVisible: false,
				dialogExpress:false,
				dialogSellers:false,
			}
		},
		methods: {
			getOrderInfo() {
				let id = this.$route.query.id;
				// let order_num = this.$route.query.order_num;
				this.httpPost({
					url: '/admin/order/order_info',
					data: {
						id: id
					}
				}).then((res) => {
					this.list = res.data;
					this.tableData = this.list.order_product;
					console.log(this.tableData)
				})
			},
			payment(val,c_id){
				
				let order_id = val;
				let customer_id = c_id;
				let order_status = 2;
				this.msgBoxAjax(
					'提示',
					'确定设为付款吗？',
					"/admin/order/payment", {
						order_id: order_id,
						order_status: order_status,
						customer_id:customer_id
					}).then((res) => {
					// console.log(data);
				
					if (res.code == 1) {
						this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
				
							this.getOrderInfo();
						});
					} else {
				
						this.messageCommon('错误', res.msg, 'error');
					}
				});
			},
			setSellersRemark(val){
				this.form2.sellers_remark = val.sellers_remark;
				this.form2.id = val.id;
				this.dialogSellers = true;
				
			},
			confirmSellersSubmit(){
				if(this.form2.sellers_remark==''){
					this.$message.error('请填写备注');
					return false;
				} 
				this.httpPost({
					url: '/admin/order/confirmSellers',
					data:this.form2
				}).then((res) => {
					if (res.code == 1) {
						this.dialogSellers = false;
						this.$message.success(res.msg);
						this.loading = false;
						this.getOrderInfo();
					}
				})
			},
			modifyOrder(val){
				this.form.id = val.order_address.id;
				this.form.customer_name = val.order_address.customer_name;
				this.form.phone = val.order_address.phone;
				this.form.street = val.order_address.street;
				this.form.state_id = [val.order_address.province_id, val.order_address.city_id]
				this.form.postcode = val.order_address.postcode;
				
				this.dialogFormVisible = true;
			},
			submit() {
				this.httpPost({
					url: '/admin/order/modify_order',
					data: {
						form: this.form
					}
				}).then((res) => {
					if (res.code == 1) {
						this.dialogFormVisible = false;
						this.$message.success(res.msg);
						this.loading = false;
						this.getOrderInfo();
					}
				})
			},
			distribution(val) {
				let order_id = val;
				let order_status = 3;
				this.msgBoxAjax(
					'提示',
					'确定修改吗？',
					"/admin/order/distribution", {
						order_id: order_id,
						order_status: order_status
					}).then((res) => {
					// console.log(data);
			
					if (res.code == 1) {
						this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
			
							this.getOrderInfo();
						});
					} else {
			
						this.messageCommon('错误', res.msg, 'error');
					}
				});
			},
			cancelDistribution(val) {
				let order_id = val;
				let order_status = 2;
				this.msgBoxAjax(
					'提示',
					'确定修改吗？',
					"/admin/order/cancelDistribution", {
						order_id: order_id,
						order_status: order_status
					}).then((res) => {
					// console.log(data);
			
					if (res.code == 1) {
						this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
			
							this.getOrderInfo();
						});
					} else {
			
						this.messageCommon('错误', res.msg, 'error');
					}
				});
			},
			confirmDelivery(val,c_id) {
				let order_id = val;
				let order_status = 4;
				let customer_id = c_id;
				this.form1={
					order_id:order_id,
					order_status:order_status,
					customer_id:customer_id,
					express_num:'',
					express_type:'',
				}
				this.dialogExpress = true;
			},
			modifyExpressNum(val){
				//修改快递单号
				console.log(val)
				this.form1.order_id = val.id;
				this.form1.express_num = val.express_num;
				this.dialogExpress = true;
			},
			confirmDeliverySubmit() {
				if (this.form1.express_num == '') {
					this.$message.error('请填写快递单号');
					return false;
				}
				if (this.form1.express_type == '') {
					this.$message.error('请选择快递类型');
					return false;
				}
				// console.log(this.form1);
				// return false;
				//共用 快递单号的弹框
				if(this.form1.order_status!=''){
					//点击发货按钮 第一次添加快递单号
					this.msgBoxAjax(
						'提示',
						'确定修改吗？',
						"/admin/order/confirmDelivery", this.form1).then((res) => {
						// console.log(data);
						this.dialogExpress = false;
						if (res.code == 1) {
							this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
					
								this.getOrderInfo();
							});
						} else {
					
							this.messageCommon('错误', res.msg, 'error');
						}
					});
				}else{
					//编辑快递单号
					this.msgBoxAjax(
						'提示',
						'确定修改吗？',
						"/admin/order/updateExpressNum", this.form1).then((res) => {
						// console.log(data);
						this.dialogExpress = false;
						if (res.code == 1) {
							this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
					
								this.getOrderInfo();
							});
						} else {
					
							this.messageCommon('错误', res.msg, 'error');
						}
					});
				}
				
			},
			getEmailTemplate(){
				let id = this.$route.query.id;
				console.log(id)
				this.httpPost({
					url: '/admin/order_email_template/order_email_template_list',
					data:{
						id:id
					}
				}).then((re) => {
					let data = re.data
					console.log(data)
					let temp = this.cloneObj(data);
					this.emailData = temp
					this.loading_email = false
							
				}).catch((err) => {})
			},
		},
		created() {
			this.getOrderInfo();
			this.getEmailTemplate();
			this.httpPost({
				url: '/admin/common/getState'
			}).then((res) => {
				this.options = res.data;
			})
		}
	}
</script>

<style>
	.box-card {
		border-radius: 0;
		border: 1px solid #ebeef5;
	}

	.order-left {
		margin-bottom: 20px;
		border-right: 1px solid #ebeef5;
	}

	.order-info {
		display: table;
		font-size: 14px;
		line-height: 28px;
	}

	.dt {
		float: left;
		width: 100px;
		color: #99A9BF;
	}

	.dd {
		padding-left: 100px;
	}

	.goods-info {
		float: left;
		width: 80%;
		margin-left: 10px;
	}

	.product-img {
		float: left;
		width: 80px;
		height: 80px;
	}

	.name {
		height: 36px;
		line-height: 18px;
		overflow: hidden;
	}

	.cs-p {
		padding: 20px !important;
	}

	.cs-fr {
		float: right;
	}
</style>
